import * as yup from "yup";

import { AccountStatuses } from "../types";

export default yup.object({
  enabled: yup.bool(),
  status: yup
    .string()
    .nullable()
    .oneOf([
      AccountStatuses.LOCKED,
      AccountStatuses.UNLOCKED,
      AccountStatuses.DEFAULT,
    ]),
});
